export default "__VITE_ASSET__BKbgP7IJ__"